import React, { createContext, useMemo, useState } from 'react';

export const UserContext = createContext(null);

export const defaultUserState = {
	username: '',
	email: '',
	phone: '',
	companyName: '',
	firstNameLastName: '',
	isLoggedIn: false,
	lastGangHochgeladenGetProjectData: false,
	showStatusBar: true,
	newsletter: false,
};

export const UserProvider = (props) => {
	const [user, setUser] = useState(defaultUserState);
	const userProviderValue = useMemo(() => ({ user, setUser }), [user, setUser]);
	return (
		<UserContext.Provider value={userProviderValue}>
			{props.children}
		</UserContext.Provider>
	);
};
